import React from 'react';
import TreatmentsTemplate from '../treatmentsTemplate/TreatmentsTemplate';

const pageTitle = 'PRP';
const pageSubTitle = 'What is PRP?';
const pageDescription = 'PRP also known as platelet rich plasma uses your own blood platelets and concentrates them for injection into the knee.  Although it is not fully proven, PRP is thought to contain "growth factors that may be helpful to reduce inflammation. Given that PRP is not FDA approved yet it does require an out-of-pocket cost.';
const videoKey = 'gO_m2G6T5dc';

const resourceLinks = [
    {
        title: 'Platelet-Rich Plasma (PRP) Injections',
        link: 'https://www.hss.edu/health-library/conditions-and-treatments/list/prp-injections',
    },
    {
        title: 'Platelet-Rich Plasma (PRP)',
        link: 'https://orthoinfo.aaos.org/en/treatment/platelet-rich-plasma-prp/',
    },
    {
        title: 'Platelet-Rich Plasma Injections: What to Know',
        link: 'https://www.webmd.com/fitness-exercise/platelet-rich-plasma-injections',
    },
];

const PRP = () => {
    return (
        <TreatmentsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={pageDescription}
            videoKey={videoKey}
            resourceLinks={resourceLinks}
            pageType="treatment"
        />
    );
};

export default PRP;